import get from 'lodash/get';
export const getBpNum = (input, breakpoint) => Number(get(input, breakpoint, get(input, '_', input)));
//# sourceMappingURL=getBpNum.js.map